import React, { useRef } from 'react';
import SatRadio from '@components/common/satUI/SatRadio';
import SatCheckBox from '../common/satUI/SatCheckBox';
import SatSignPad from '@components/common/satUI/SatSignPad';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';
import SatButton from '@components/common/satUI/SatButton';

const HealthCarePopup = props => {
  const {
    health,
    onChange,
    pasteCheck,
    pasteCheck2,
    onClickPasteCheck,
    isFollowTxtError,
    signNameData,
    signNameData2,
    signatureData,
    signatureData2,
    name,
    signPasteData,
    complete,
    signData,
    setSignNameData,
    setSignNameData2,
    setPasteCheck,
    setPasteCheck2,
    setSignatureData,
    setSignatureData2,
    isValid,
    isValidCheck,
    isPracticeMode,
    practiceSignName,
    practiceSignature,
  } = props;
  const canvasNameRef1 = useRef();
  const canvasSignRef1 = useRef();
  const canvasNameRef2 = useRef();
  const canvasSignRef2 = useRef();
  return (
    <>
      <header className="modal-header">
        <h3 className="layer-tit2">{`[선택] 헬스케어 서비스 동의서`}</h3>
      </header>
      <div className="cont modal-scroll-wrap">
        <p className="text-info4">{`아래 문항에 체크 및 서명해주세요.`}</p>
        <div className="txt-pad-wrap">
          <h4 className="tit-small">
            {`1. 개인(신용)정보의 수집·이용에 관한 사항`}
          </h4>
          <p className="text-con">
            {`당사는 「개인정보보호법」 및 「신용정보의 이용 및 보호에 관한
            법률」에 따라 (주)AAI헬스케어 서비스 가입 및 홍보 등을 위하여 귀하의
            개인(신용)정보를 다음과 같이 수집·이용하고자 합니다.`}
          </p>
          <div className="infor-list border-t">
            <div className="insu-box">
              <div className="txt-question">
                <p>
                  {`위 개인 신용정보 `}<span className="under">수집·이용</span>에 동의하십니까?
                </p>
              </div>
              <div className="inp-list2">
                <SatRadio
                  name="q1"
                  checkOne
                  value={health.q1}
                  options={[
                    {
                      label: '동의함',
                      value: '0',
                    },
                    { label: '동의하지 않음', value: '1' },
                  ]}
                  onChange={value => onChange('q1',value.value)}
                />
              </div>            
            </div>
          </div>
          <h4 className="tit-small mgt-24">
            {`2. 개인(신용)정보의 제공에 관한 사항`}
          </h4>
          <p className="text-con">
            {`당사는 「개인정보보호법」 및 「신용정보의 이용 및 보호에 관한
            법률」에 따라 귀하의 개인(신용)정보를 다음과 같이
            (주)AAI헬스케어서비스 가입 및 홍보 등 영업목적으로 제공하고자
            합니다.`}
          </p>
          <div className="infor-list border-t">
            <div className="insu-box">
              <div className="txt-question">
                <p>
                  {`위 개인 신용정보 `}<span className="under">제공</span>에 동의하십니까??
                </p>
              </div>
              <div className="inp-list2">
                <SatRadio
                  name="q2"
                  checkOne
                  value={health.q2}
                  options={[
                    {
                      label: '동의함',
                      value: '0',
                    },
                    { label: '동의하지 않음', value: '1' },
                  ]}
                  onChange={value => onChange('q2',value.value)}
                />
              </div>
            </div>
          </div>
          <SatValidationErrMsg
            visible={(isFollowTxtError && health.q1 === '') || (isFollowTxtError && health.q2 === '')}
            type="error"
            message="내용을 확인하고 입력해주세요."
          />
        </div>
        <SatCheckBox
          value={[pasteCheck]}
          type={'radio'}
          options={[
            { label: '저장했던 성명/서명을 붙여넣으세요.', value: false },
          ]}
          onChange={v => onClickPasteCheck('s1',v)}
          customStyleClass="small w-360"
        />
        <div className="sign-pad-wrap">
          <SatSignPad
            canvasRef={canvasNameRef1}
            name={name}
            title={'피보험자 성명 입력'}
            error={
              isFollowTxtError && !signNameData ? '성명을 입력해주세요.' : ''
            }
            pasteCheck={pasteCheck}
            pasteData={
              !isPracticeMode
                ? signPasteData.app_form_etc_18_sign_01
                : practiceSignName
            }
            signData={complete ? signData.app_form_etc_27_signid_01 : ''}
            onChange={data => setSignNameData(data)}
            onChangePasteCheck={value => setPasteCheck(value)}
          />
          <SatSignPad
            canvasRef={canvasSignRef1}
            name={'서명'}
            title={'피보험자 서명 입력'}
            error={
              isFollowTxtError && !signatureData ? '서명을 입력해주세요.' : ''
            }
            pasteCheck={pasteCheck}
            pasteData={
              !isPracticeMode
                ? signPasteData.app_form_etc_18_sign_02
                : practiceSignature
            }
            signData={complete ? signData.app_form_etc_27_signid_02 : ''}
            onChange={data => setSignatureData(data)}
            onChangePasteCheck={value => setPasteCheck(value)}
          />
        </div>
        <div id="healthService">
          <div className="txt-pad-wrap">
            <h3 className="layer-tit2">{`헬스케어 서비스 이용신청서`}</h3>
              <p className="text-con">
                {`본인은 AAI 헬스케어 서비스의 주요내용에 대하여 
                충분한 설명을 듣고 이해하였으며,
                자필 성명/서명하여 헬스케어 서비스를 신청합니다.`}
              </p>
          </div>
          <SatCheckBox
            value={[pasteCheck2]}
            type={'radio'}
            options={[
              { label: '저장했던 성명/서명을 붙여넣으세요.', value: false },
            ]}
            onChange={v => onClickPasteCheck('s2',v)}
            customStyleClass="small w-360"
          />
          <div className="sign-pad-wrap">
            <SatSignPad
              canvasRef={canvasNameRef2}
              name={name}
              title={'피보험자 성명 입력'}
              error={
                isFollowTxtError && !signNameData2 ? '성명을 입력해주세요.' : ''
              }
              pasteCheck2={pasteCheck2}
              pasteData={
                !isPracticeMode
                  ? signPasteData.app_form_etc_18_sign_01
                  : practiceSignName
              }
              signData={complete ? signData.app_form_etc_27_signid_03 : ''}
              onChange={data => setSignNameData2(data)}
              onChangePasteCheck2={value => setPasteCheck2(value)}
            />
            <SatSignPad
              canvasRef={canvasSignRef2}
              name={'서명'}
              title={'피보험자 서명 입력'}
              error={
                isFollowTxtError && !signatureData2 ? '서명을 입력해주세요.' : ''
              }
              pasteCheck2={pasteCheck2}
              pasteData={
                !isPracticeMode
                  ? signPasteData.app_form_etc_18_sign_02
                  : practiceSignature
              }
              signData={complete ? signData.app_form_etc_27_signid_04 : ''}
              onChange={data => setSignatureData2(data)}
              onChangePasteCheck2={value => setPasteCheck2(value)}
            />
          </div>
        </div>
      </div>
      <div className="layer-footer">
        <SatButton
          styleClass={`btn-s blue btn-wide ${!isValid && 'disabled'}`}
          label={'확인'}
          onClick={() => isValidCheck()}
        />
      </div>
    </>
  );
};

export default HealthCarePopup;
